// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1WorkflowReferences = async (url: string, request: Types.GetV1WorkflowReferencesRequest): Promise<Types.GetV1WorkflowReferencesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowReferences: Api['getV1WorkflowReferences'] = async (request: Types.GetV1WorkflowReferencesRequest): Promise<Types.GetV1WorkflowReferencesResponses> => {
  return await _getV1WorkflowReferences(baseUrl, request)
}
const _getV1WorkflowReferencesType = async (url: string, request: Types.GetV1WorkflowReferencesTypeRequest): Promise<Types.GetV1WorkflowReferencesTypeResponses> => {
  const queryParameters: (keyof Types.GetV1WorkflowReferencesTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/${request['type']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowReferencesType: Api['getV1WorkflowReferencesType'] = async (request: Types.GetV1WorkflowReferencesTypeRequest): Promise<Types.GetV1WorkflowReferencesTypeResponses> => {
  return await _getV1WorkflowReferencesType(baseUrl, request)
}
const _putV1WorkflowReferencesType = async (url: string, request: Types.PutV1WorkflowReferencesTypeRequest): Promise<Types.PutV1WorkflowReferencesTypeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/${request['type']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkflowReferencesType: Api['putV1WorkflowReferencesType'] = async (request: Types.PutV1WorkflowReferencesTypeRequest): Promise<Types.PutV1WorkflowReferencesTypeResponses> => {
  return await _putV1WorkflowReferencesType(baseUrl, request)
}
const _getV1WorkflowReferencesHierarchicalType = async (url: string, request: Types.GetV1WorkflowReferencesHierarchicalTypeRequest): Promise<Types.GetV1WorkflowReferencesHierarchicalTypeResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/hierarchical/${request['type']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowReferencesHierarchicalType: Api['getV1WorkflowReferencesHierarchicalType'] = async (request: Types.GetV1WorkflowReferencesHierarchicalTypeRequest): Promise<Types.GetV1WorkflowReferencesHierarchicalTypeResponses> => {
  return await _getV1WorkflowReferencesHierarchicalType(baseUrl, request)
}
const _postV1WorkflowReferencesTypeItems = async (url: string, request: Types.PostV1WorkflowReferencesTypeItemsRequest): Promise<Types.PostV1WorkflowReferencesTypeItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/${request['type']}/items`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkflowReferencesTypeItems: Api['postV1WorkflowReferencesTypeItems'] = async (request: Types.PostV1WorkflowReferencesTypeItemsRequest): Promise<Types.PostV1WorkflowReferencesTypeItemsResponses> => {
  return await _postV1WorkflowReferencesTypeItems(baseUrl, request)
}
const _deleteV1WorkflowReferencesTypeItemsValue = async (url: string, request: Types.DeleteV1WorkflowReferencesTypeItemsValueRequest): Promise<Types.DeleteV1WorkflowReferencesTypeItemsValueResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/${request['type']}/items/${request['value']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkflowReferencesTypeItemsValue: Api['deleteV1WorkflowReferencesTypeItemsValue'] = async (request: Types.DeleteV1WorkflowReferencesTypeItemsValueRequest): Promise<Types.DeleteV1WorkflowReferencesTypeItemsValueResponses> => {
  return await _deleteV1WorkflowReferencesTypeItemsValue(baseUrl, request)
}
const _getV1WorkflowReferencesFieldsEntityType = async (url: string, request: Types.GetV1WorkflowReferencesFieldsEntityTypeRequest): Promise<Types.GetV1WorkflowReferencesFieldsEntityTypeResponses> => {
  const queryParameters: (keyof Types.GetV1WorkflowReferencesFieldsEntityTypeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/fields/${request['entity_type']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowReferencesFieldsEntityType: Api['getV1WorkflowReferencesFieldsEntityType'] = async (request: Types.GetV1WorkflowReferencesFieldsEntityTypeRequest): Promise<Types.GetV1WorkflowReferencesFieldsEntityTypeResponses> => {
  return await _getV1WorkflowReferencesFieldsEntityType(baseUrl, request)
}
const _getV1WorkflowReferencesOperatorsEntityTypeFieldName = async (url: string, request: Types.GetV1WorkflowReferencesOperatorsEntityTypeFieldNameRequest): Promise<Types.GetV1WorkflowReferencesOperatorsEntityTypeFieldNameResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/operators/${request['entity_type']}/${request['field_name']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowReferencesOperatorsEntityTypeFieldName: Api['getV1WorkflowReferencesOperatorsEntityTypeFieldName'] = async (request: Types.GetV1WorkflowReferencesOperatorsEntityTypeFieldNameRequest): Promise<Types.GetV1WorkflowReferencesOperatorsEntityTypeFieldNameResponses> => {
  return await _getV1WorkflowReferencesOperatorsEntityTypeFieldName(baseUrl, request)
}
const _getV1WorkflowReferencesEntityFieldOptionsEntityType = async (url: string, request: Types.GetV1WorkflowReferencesEntityFieldOptionsEntityTypeRequest): Promise<Types.GetV1WorkflowReferencesEntityFieldOptionsEntityTypeResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-references/entity-field-options/${request['entity_type']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowReferencesEntityFieldOptionsEntityType: Api['getV1WorkflowReferencesEntityFieldOptionsEntityType'] = async (request: Types.GetV1WorkflowReferencesEntityFieldOptionsEntityTypeRequest): Promise<Types.GetV1WorkflowReferencesEntityFieldOptionsEntityTypeResponses> => {
  return await _getV1WorkflowReferencesEntityFieldOptionsEntityType(baseUrl, request)
}
const _getV1Workflows = async (url: string, request: Types.GetV1WorkflowsRequest): Promise<Types.GetV1WorkflowsResponses> => {
  const queryParameters: (keyof Types.GetV1WorkflowsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Workflows: Api['getV1Workflows'] = async (request: Types.GetV1WorkflowsRequest): Promise<Types.GetV1WorkflowsResponses> => {
  return await _getV1Workflows(baseUrl, request)
}
const _postV1Workflows = async (url: string, request: Types.PostV1WorkflowsRequest): Promise<Types.PostV1WorkflowsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Workflows: Api['postV1Workflows'] = async (request: Types.PostV1WorkflowsRequest): Promise<Types.PostV1WorkflowsResponses> => {
  return await _postV1Workflows(baseUrl, request)
}
const _getV1WorkflowsId = async (url: string, request: Types.GetV1WorkflowsIdRequest): Promise<Types.GetV1WorkflowsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowsId: Api['getV1WorkflowsId'] = async (request: Types.GetV1WorkflowsIdRequest): Promise<Types.GetV1WorkflowsIdResponses> => {
  return await _getV1WorkflowsId(baseUrl, request)
}
const _putV1WorkflowsId = async (url: string, request: Types.PutV1WorkflowsIdRequest): Promise<Types.PutV1WorkflowsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkflowsId: Api['putV1WorkflowsId'] = async (request: Types.PutV1WorkflowsIdRequest): Promise<Types.PutV1WorkflowsIdResponses> => {
  return await _putV1WorkflowsId(baseUrl, request)
}
const _deleteV1WorkflowsId = async (url: string, request: Types.DeleteV1WorkflowsIdRequest): Promise<Types.DeleteV1WorkflowsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkflowsId: Api['deleteV1WorkflowsId'] = async (request: Types.DeleteV1WorkflowsIdRequest): Promise<Types.DeleteV1WorkflowsIdResponses> => {
  return await _deleteV1WorkflowsId(baseUrl, request)
}
const _postV1WorkflowsIdToggle = async (url: string, request: Types.PostV1WorkflowsIdToggleRequest): Promise<Types.PostV1WorkflowsIdToggleResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/${request['id']}/toggle`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkflowsIdToggle: Api['postV1WorkflowsIdToggle'] = async (request: Types.PostV1WorkflowsIdToggleRequest): Promise<Types.PostV1WorkflowsIdToggleResponses> => {
  return await _postV1WorkflowsIdToggle(baseUrl, request)
}
const _postV1WorkflowsTestTransform = async (url: string, request: Types.PostV1WorkflowsTestTransformRequest): Promise<Types.PostV1WorkflowsTestTransformResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflows/test-transform`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkflowsTestTransform: Api['postV1WorkflowsTestTransform'] = async (request: Types.PostV1WorkflowsTestTransformRequest): Promise<Types.PostV1WorkflowsTestTransformResponses> => {
  return await _postV1WorkflowsTestTransform(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1WorkflowReferences: _getV1WorkflowReferences.bind(url, ...arguments),
    getV1WorkflowReferencesType: _getV1WorkflowReferencesType.bind(url, ...arguments),
    putV1WorkflowReferencesType: _putV1WorkflowReferencesType.bind(url, ...arguments),
    getV1WorkflowReferencesHierarchicalType: _getV1WorkflowReferencesHierarchicalType.bind(url, ...arguments),
    postV1WorkflowReferencesTypeItems: _postV1WorkflowReferencesTypeItems.bind(url, ...arguments),
    deleteV1WorkflowReferencesTypeItemsValue: _deleteV1WorkflowReferencesTypeItemsValue.bind(url, ...arguments),
    getV1WorkflowReferencesFieldsEntityType: _getV1WorkflowReferencesFieldsEntityType.bind(url, ...arguments),
    getV1WorkflowReferencesOperatorsEntityTypeFieldName: _getV1WorkflowReferencesOperatorsEntityTypeFieldName.bind(url, ...arguments),
    getV1WorkflowReferencesEntityFieldOptionsEntityType: _getV1WorkflowReferencesEntityFieldOptionsEntityType.bind(url, ...arguments),
    getV1Workflows: _getV1Workflows.bind(url, ...arguments),
    postV1Workflows: _postV1Workflows.bind(url, ...arguments),
    getV1WorkflowsId: _getV1WorkflowsId.bind(url, ...arguments),
    putV1WorkflowsId: _putV1WorkflowsId.bind(url, ...arguments),
    deleteV1WorkflowsId: _deleteV1WorkflowsId.bind(url, ...arguments),
    postV1WorkflowsIdToggle: _postV1WorkflowsIdToggle.bind(url, ...arguments),
    postV1WorkflowsTestTransform: _postV1WorkflowsTestTransform.bind(url, ...arguments)
  }
}